module.exports = __webpack_public_path__ + "static/man-y-e2db4f1e19ce3c7f346e6e01ebba9382.jpg";